// extracted by mini-css-extract-plugin
module.exports = {"distance":"_02712f2b3b--distance--ZCgXU","distance-icon":"_02712f2b3b--distance-icon--kn1Hg","distance-text":"_02712f2b3b--distance-text--IE_xg"};